import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { LogActivityResponseInterface } from "@/types/interface/log-activity";

async function getLogActivity(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<LogActivityResponseInterface>>(`log-activity?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findLogActivity(idLogActivity = "") {
  return await http.get<APIResponse<LogActivityResponseInterface>>(`log-activity/detail?id=${idLogActivity}`);
}

export default {
  getLogActivity,
  findLogActivity
};